import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import TagesraportPanel from "../components/TagesraportPanel";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function Tagesraporte() {
  const { user, isAdmin } = useAuth();
  const [persons, setPersons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePid, setActivePid] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get("/tagesraporte/eligible-persons")
      .then((r) => {
        const list = r.data || [];
        setPersons(list);
        // Default: ownership pentru cei 3, altfel primul din listă
        if (!isAdmin && user?.person_id && list.find((p) => p.id === user.person_id)) {
          setActivePid(user.person_id);
        } else if (list.length > 0) {
          setActivePid(list[0].id);
        }
      })
      .catch(() => setPersons([]))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  // Non-admin user-i restrânși la propriul lor profil (dacă sunt eligibili)
  const visiblePersons = isAdmin
    ? persons
    : persons.filter((p) => p.id === user?.person_id);

  if (loading) {
    return <div className="p-6 text-sm text-zinc-500 italic">Se încarcă...</div>;
  }
  if (visiblePersons.length === 0) {
    return (
      <div className="p-6 max-w-xl">
        <h1 className="font-display text-2xl font-extrabold mb-2">📝 Tagesraport</h1>
        <div className="card-flat p-5 text-sm text-zinc-600">
          Tagesraport este disponibil doar pentru Khreis Christian, Istratenco Serghei și Stoica Elena Lorena.
        </div>
      </div>
    );
  }

  return (
    <div className="p-2" data-testid="page-tagesraporte">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <div>
          <h1 className="font-display text-3xl font-extrabold">📝 Tagesraport</h1>
          <p className="text-xs text-zinc-500 mt-1">Raport zilnic — task-uri + durată per persoană.</p>
        </div>
      </div>

      {visiblePersons.length === 1 ? (
        <div className="card-flat p-5">
          <div className="mb-3 text-sm font-semibold text-zinc-700">
            {`${visiblePersons[0].prenume || ""} ${visiblePersons[0].nume || ""}`.trim()}
          </div>
          <TagesraportPanel
            personId={visiblePersons[0].id}
            personName={`${visiblePersons[0].prenume || ""} ${visiblePersons[0].nume || ""}`.trim()}
            canEdit={isAdmin || user?.person_id === visiblePersons[0].id}
          />
        </div>
      ) : (
        <Tabs value={activePid || visiblePersons[0]?.id} onValueChange={setActivePid}>
          <TabsList className="flex-wrap h-auto">
            {visiblePersons.map((p) => (
              <TabsTrigger key={p.id} value={p.id} data-testid={`tag-person-${p.id}`}>
                {`${p.prenume || ""} ${p.nume || ""}`.trim()}
              </TabsTrigger>
            ))}
          </TabsList>
          {visiblePersons.map((p) => (
            <TabsContent key={p.id} value={p.id}>
              <div className="card-flat p-5 mt-2">
                <TagesraportPanel
                  personId={p.id}
                  personName={`${p.prenume || ""} ${p.nume || ""}`.trim()}
                  canEdit={isAdmin || user?.person_id === p.id}
                />
              </div>
            </TabsContent>
          ))}
        </Tabs>
      )}
    </div>
  );
}
